module.exports = __webpack_public_path__ + "img/cs-icons-linkedin-filled.4d6d8d7b.svg";